<h5 (click)="downloadFile()">
  <i data-toggle="modal" class="icon icon-info info-new" title="{{fileName}}"></i>&nbsp;&nbsp;
  <a data-toggle="modal" class="a_custom">{{fileName}}</a>
</h5>
